import { SortDirection } from '@rio-cloud/rio-uikit';
import Button from "@rio-cloud/rio-uikit/Button";
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useAppSelector } from '@/configuration/setup/hooks';
import { useSendQuestionMutation } from '@/services/chatApi/chatApi';
import { selectAllLoadedThreads, selectIsHistoryOfThreadsFetching, selectPagination } from '@/store/thread/threadSlice';
import { isSortDirection } from '@/utils/sortHelper/sortHelper';

import { ThreadsInfo } from './Style';
import { ThreadsListControlBarProps } from './types';



const texts = {
  sort: 'chatPage.chatThreadList.sort.label',
  threads: 'chatPage.chatThreadList.threads.label',
} as const;

const ThreadsListControlBar = ({ changeSortOrder }: ThreadsListControlBarProps) => {
  const intl = useIntl();
  const isLoading = useAppSelector(selectIsHistoryOfThreadsFetching);
  const allLoadedThreads = useAppSelector(selectAllLoadedThreads);
  const pagination = useAppSelector(selectPagination);

  // INFO: Defines sort order, sets descending order by default
  const sortOrder = useMemo(() => isSortDirection(pagination?.sortOrder) ? pagination.sortOrder : SortDirection.DESCENDING, [pagination.sortOrder])

  const [, { isLoading: isSendMessageLoading }] = useSendQuestionMutation();
  
const isChangeSortorderDisabled = isLoading || isSendMessageLoading;
  
const buttonIcon = sortOrder === SortDirection.DESCENDING ? 'rioglyph rioglyph-sort-by-attributes' : 'rioglyph rioglyph-sort-by-attributes-alt';

  return (
    <div className="display-flex align-items-center justify-content-between padding-x-20 bg-lightest">
        <div className="display-flex align-items-center">
            <ThreadsInfo>{intl.formatMessage({id: texts.sort})}</ThreadsInfo>
            <Button
                type="button"
                className="btn btn-info btn-link"
                disabled={isChangeSortorderDisabled}
                onClick={changeSortOrder}
                data-testid="thread-sort-toggle-button"
            >
                <span className={buttonIcon} aria-hidden="true"/>
            </Button>
        </div>
        <ThreadsInfo>
            {intl.formatMessage({id: texts.threads})} {allLoadedThreads}/{pagination.totalThreads}
        </ThreadsInfo>
    </div>
  );
};

export default ThreadsListControlBar;
